import React from 'react';
import { Measurement, MeasurementStatus } from '../services/measurementService';
import './MeasurementsTable.css';

interface MeasurementsTableProps {
  measurements: Measurement[];
  onRowClick: (measurementId: string) => void;
}

const MeasurementsTable: React.FC<MeasurementsTableProps> = ({ measurements, onRowClick }) => {
  const getStatusColor = (status: MeasurementStatus): string => {
    const normalizedStatus = status.toLowerCase();
    switch (normalizedStatus) {
      case 'creating':
      case 'processing':
        return '#F59E0B'; // amber
      case 'upcoming':
        return '#57BBE8'; // blue
      case 'active':
        return '#64CE76'; // green
      case 'reported':
        return '#37077A'; // purple
      case 'failed':
        return '#DC2626'; // red
      default:
        return '#6B7280'; // gray fallback
    }
  };

  const getStatusLabel = (status: MeasurementStatus): string => {
    const normalizedStatus = status.toLowerCase();
    switch (normalizedStatus) {
      case 'creating':
        return 'Creating';
      case 'processing':
        return 'Processing';
      case 'upcoming':
        return 'Upcoming';
      case 'active':
        return 'Active';
      case 'reported':
        return 'Reported';
      case 'failed':
        return 'Failed';
      default:
        return status;
    }
  };

  return (
    <div className="measurements-table-container">
      <table className="measurements-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Name</th>
            <th className="hide-on-mobile">Advertiser</th>
            <th className="hide-on-mobile">Brand</th>
            <th className="hide-on-mobile">Created</th>
          </tr>
        </thead>
        <tbody>
          {measurements.map((measurement) => (
            <tr 
              key={measurement.id}
              className="measurement-row"
              onClick={() => onRowClick(measurement.id)}
            >
              <td className="measurement-status">
                <div className="status-icon-container" title={getStatusLabel(measurement.status)}>
                  <div 
                    className="status-icon"
                    style={{ backgroundColor: getStatusColor(measurement.status) }}
                  />
                </div>
              </td>
              <td className="measurement-name">{measurement.name}</td>
              <td className="measurement-advertiser hide-on-mobile">{measurement.advertiser}</td>
              <td className="measurement-brand hide-on-mobile">{measurement.brand || '—'}</td>
              <td className="measurement-date hide-on-mobile">
                {new Date(measurement.createdAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MeasurementsTable;
